import env from "react-dotenv";


const local = {
    API_URL: "http://localhost:8000/api",
    ADMIN_URL: "http://localhost:8000/admin"
}

const staging = {
    API_URL: "http://localhost:8000/api",
    ADMIN_URL: "http://localhost:8000/admin"
}

const production = {
    API_URL: "https://workbooks.services.mermaiddevs.com/api",
    ADMIN_URL: "https://workbooks.services.mermaiddevs.com/admin/"
}


let config;

if (env.REACT_APP_STAGE === 'local') {
    config = local
} else if (env.REACT_APP_STAGE === 'production') {
    config = production
} else {
    config = staging
}

export default config;
